import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useQuarantineDefectPictureV1ControllerGetByDefect } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetDefectPicturesData = (defectId: string | undefined) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityScan);

  const { data, error, isLoading } =
    useQuarantineDefectPictureV1ControllerGetByDefect({
      queryParams: {
        defectId: defectId ?? '',
      },
      headers: restHeaders,
    });

  return {
    data,
    isLoading,
    error,
  };
};
